import { ConfirmationModalProps } from './confirmation-modal.types'
import { ModalHeader } from '../modal-header'
import { ModalTitle } from '../modal-title'
import { ModalContent } from '../modal-content'
import { ModalFooter } from '../modal-footer'
import { Button } from '../button'
import { Icon } from '../icon'

export const ConfirmationModal = ({
  title,
  primaryButtonText,
  secondaryButtonText,
  children,
  type,
  variant,
  disabled,
  loading,
  loadingText,
  handleClose,
  handleSubmit,
  primaryBtnTestId,
  secondaryBtnTestId,
  maxHeight,
  buttonShape,
}: ConfirmationModalProps) => {
  return (
    <>
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
        {/* Inert while submitting, rather than silently swallowing clicks. */}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            flexGrow: 1,
            padding: 4,
            cursor: loading ? 'default' : 'pointer',
            pointerEvents: loading ? 'none' : undefined,
          }}
          onClick={loading ? undefined : handleClose}
        >
          <Icon name="close" size={4} color="gray600" />
        </div>
      </ModalHeader>
      <ModalContent maxHeight={maxHeight}>{children}</ModalContent>
      <ModalFooter>
        {secondaryButtonText && (
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={loading}
            data-testid={secondaryBtnTestId}
            size="medium"
            shape={buttonShape}
          >
            {secondaryButtonText || 'Cancel'}
          </Button>
        )}
        <Button
          onClick={handleSubmit}
          type={type}
          variant={variant}
          disabled={disabled}
          loading={loading}
          loadingText={loadingText}
          data-testid={primaryBtnTestId}
          size="medium"
          shape={buttonShape}
        >
          {primaryButtonText}
        </Button>
      </ModalFooter>
    </>
  )
}
